import { combineReducers } from '@reduxjs/toolkit';

import accountsSlice, * as fromAccounts from './accountSlice';
import accountUsersSlice, * as fromAccountUsers from './accountUsersSlice';
import authReducer, * as fromAuth from './authSlice';
import billingInformationSlice, * as fromBillingInformation from './billingInformationSlice';
import invoiceSlice, * as fromInvoices from './invoiceSlice';
import layoutSlice, * as fromLayout from './layoutSlice';
import orderReducer, * as fromOrder from './orderSlice';
import paymentMethodSlice, * as fromPaymentMethod from './paymentMethodSlice';
import subscriptionReducer, * as fromSubscription from './subscriptionSlice';
import surveyReducer, * as fromSurvey from './surveySlice';
import usersReducer, * as fromUsers from './usersSlice';
import organizationsReducer, * as fromOrganizations from './organizationsSlice';
import accountFeatureFlagSlice, * as fromAccountFeatureFlag from './accountFeatureFlagSlice';
import organizationFeatureFlagSlice, * as fromOrganizationFeatureFlag from './organizationFeatureFlagSlice';
import promotionReducer, * as fromPromotion from './promotionSlice';

const rootReducer = combineReducers({
  [fromAccountUsers.ACCOUNT_USERS_FEATURE_KEY]: accountUsersSlice,
  [fromAccounts.ACCOUNT_FEATURE_KEY]: accountsSlice,
  [fromAuth.AUTH_FEATURE_KEY]: authReducer,
  [fromBillingInformation.BILLING_INFORMATION_FEATURE_KEY]: billingInformationSlice,
  [fromInvoices.INVOICE_FEATURE_KEY]: invoiceSlice,
  [fromLayout.LAYOUT_FEATURE_KEY]: layoutSlice,
  [fromOrder.ORDER_FEATURE_KEY]: orderReducer,
  [fromPaymentMethod.PAYMENT_METHOD_FEATURE_KEY]: paymentMethodSlice,
  [fromSubscription.SUBSCRIPTION_FEATURE_KEY]: subscriptionReducer,
  [fromSurvey.SURVEY_FEATURE_KEY]: surveyReducer,
  [fromUsers.USER_FEATURE_KEY]: usersReducer,
  [fromOrganizations.ORGANIZATION_FEATURE_KEY]: organizationsReducer,
  [fromAccountFeatureFlag.ACCOUNT_FEATURE_FLAG_KEY]: accountFeatureFlagSlice,
  [fromOrganizationFeatureFlag.ORGANIZATION_FEATURE_FLAG_FEATURE_KEY]: organizationFeatureFlagSlice,
  [fromPromotion.PROMOTION_FEATURE_KEY]: promotionReducer,
});

export {
  fromAccounts,
  fromAccountUsers,
  fromAuth,
  fromBillingInformation,
  fromInvoices,
  fromLayout,
  fromOrder,
  fromPaymentMethod,
  fromSubscription,
  fromSurvey,
  fromUsers,
  fromOrganizations,
  fromAccountFeatureFlag,
  fromOrganizationFeatureFlag,
  fromPromotion,
};
export default rootReducer;
